import * as React from "react";
import { Link } from "react-router-dom";

import Profile from "./Profile";

import Logo from "./../../Images/logo.png";

import "./TopBar.scss";

const TopBar = () => {
  return (
    <div className="navbar">
      <div className="left-side">
        <Link to="/" className="logo">
          <img
            src={Logo}
            alt="Attijari Leasing Tunisie, Crédit Leasing Tunisie | Attijari"
          />
        </Link>
      </div>
      <div className="right-side">
        <Profile />
      </div>
    </div>
  );
};

export default TopBar;
